<template>
  <!-- {{ ReservationDetails }} -->
   <body style="font-size:12pt">
       <div id="page-wrap">
    <div id="receipt">
        <!-- <div class="col-lg-12">
          <a href="../"></a>
          <div id="logo">
        <img src="../../assets/img/logo81-min.png" /> -->
      <!-- </div> -->
        <div class="col-lg-12 text-center" >
          <h6><b>{{ GetShopInfo?GetShopInfo.name:"" }}</b></h6>
        </div>
        <div class="col-lg-12 text-center">
          <h6> {{ GetShopInfo.address? GetShopInfo.address.address_line1:"" }},
            {{ GetShopInfo.address?GetShopInfo.address.city:"" }},
            {{ GetShopInfo.address?GetShopInfo.address.country.name:"" }}</h6>
        </div>
        <div class="col-lg-12 text-center">
          <h6>{{
              GetShopInfo.contact? GetShopInfo.contact.phone:""
            }}</h6>
            <a
              v-if="GetShopInfo.contact && GetShopInfo.contact.telephone && GetShopInfo.contact.phone"
              >/</a
            >
            <h6>{{
              GetShopInfo.contact?GetShopInfo.contact.telephone:""
            }}</h6>
        </div>
          <div class="col-lg-12 text-center">
          <h6> {{
              GetShopInfo.contact?GetShopInfo.contact.email:""
            }}</h6>
        </div>
    
  
        <hr style="border-top: 1px dashed black;" />
      <div class="row">
        <div class="col-lg-12">
          <div class="column">
            <div class="row">
              <div class="col-sm-2 textlabel">
                <label for="">Reference No </label>
              </div>
              <div class="col-sm-5 textlabel">
                <label for="" style="font-weight:bold; ">
                 {{ quotationdata != null && quotationdata.reference_number }}
                </label>
              </div>
              <div class="col-sm-2 textlabel">
                <label for="">Valid Date</label>
              </div>
              <div class="col-sm-3 textlabel">
                <label for="" style="font-weight:bold;">
                  {{ quotationdata != null && quotationdata.valid_date | formatDate }} 
                </label>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-2 textlabel">
                <label for="">Customer </label>
              </div>
              <div class="col-sm-5 textlabel">
                <label for="" style="font-weight:bold; ">
                  {{ quotationdata != null && quotationdata.customer.name }}
                </label>
              </div>
              
              <!-- <div class="col-sm-2 textlabel">
                <label for="">Create By</label>
              </div>
              <div class="col-sm-3 textlabel">
                <label for="" style="font-weight:bold; ">
                  {{
                    quotationdata.date 
                  }}
                </label>
              </div> -->
               <div class="col-sm-2 textlabel">
                <label for="">Create By</label>
              </div>
              <div class="col-sm-3 textlabel">
                <label for="" style="font-weight:bold; ">
                  {{
                    quotationdata != null && quotationdata.biller.first_name
                  }}
                </label>
              </div>
               <div
                class="col-sm-2 textlabel"
              >
                <label for="">Shop </label>
              </div>
              <div class="col-sm-5 textlabel">
                <label for="" style="font-weight:bold; ">
                  {{ quotationdata != null && quotationdata.shop.name }}
                </label>
              </div>
            </div>
            
          </div>
        </div>
      </div>
    
        
      
    
    <hr style="border-top: 1px dashed black;" />
      <table id="items" width=1000 border=0 cellpadding=1 cellspacing=0>
        <tr>
          <th  style="border:none;border-bottom:3px solid grey;">Description</th>
          <th  style="border:none;border-bottom:3px solid grey;">Unit</th>
          <th  style="border:none;border-bottom:3px solid grey;"> Batch</th>
          <th style="border:none;border-bottom:3px solid grey;">Quantity</th>
          <th  style="border:none;border-bottom:3px solid grey;">Unit Cost</th>
           <th  style="border:none;border-bottom:3px solid grey;">Discount%</th>
            <th  style="border:none;border-bottom:3px solid grey;">Amount</th>
        </tr>
        <tr></tr>
        <tr class="item-row" v-for="(item, index) in (quotationdata != null && quotationdata.quotationItem)">
          <td>{{ item.product.name }}</td>
              <td>{{ item.unit.name }}</td>
              <td>{{ item.batch.batch }}</td>
              <td>{{ item.quantity }}</td>
               <td>{{ item.batch.selling_price }}</td>
              <td>{{ item.discount }}</td>
              <td>{{ item.quantity * item.amount }}.00</td>
        </tr>
      </table>


      <table id="items" width=1000 border=0 cellpadding=1 cellspacing=0>
  
        
<p class="text-center"></p>
        <tr>
          <td style="border:none" colspan="1" class="blank"></td>
          <td
            style="border:none; "
            colspan="1"
          
          >
          <p class="text-left">Date</p>
          
          </td>
          <td style="border:none" >
            <div><p class="text-right" style="font-weight:bold"> {{quotationdata != null && quotationdata.date |formatDate }}</p></div>
          </td>
        </tr>
        
        <tr>
          <td colspan="1" style="border:none"></td>
          <td
            colspan="1"
        
            style="border:none;"
          ><p class="text-left" > Discount</p>
          
          </td>
          <td  style="border:none">
            <div><p class="text-right" style="font-weight:bold"> {{quotationdata != null && quotationdata.discount }}</p></div>
          </td>
        </tr>
        <tr>
          <td colspan="1"  style="border:none"></td>
          <td
            colspan="1"
        
            style="border:none;"
          >
          <p class="text-left"> Total Amount</p>
            
          </td>
          <td style="border:none">
            <div><p class="text-right" style="font-weight:bold" > {{ quotationdata != null && quotationdata.total }}</p></div>
          </td>
        </tr>
      
     
       
      </table>
              
          <hr style="border-top: 1px dashed black;" />
      <div >
        <p style="font-weight:bold" class="text-center">Thank You</p>
        <p class="text-center">Powered by &#169;www.speedcodelabs.com || &#9742; 0212211599</p>
      </div>
      <p  style="page-break-after:always;"></p> 
     </div>
    </div>
  </body>
</template>
<script>
import { mapGetters } from "vuex";
import axios from "@/plugins/axios";
import moment from "moment";
export default {
     props: {
    quotationdata: {
      type: Object,
      default: {},
    },
     },
  data() {
    return {
      ReservationDetails: [],
    };
  },

   computed: {
    ...mapGetters("auth", ["GetUserName"]),
    ...mapGetters("masterData", ["GetOrganization"]),
    ...mapGetters("shops", ["GetShopInfo"]),
    
  },
  methods: {
       prints() {
      this.$htmlToPaper("receipt");
    },

   
  },
};
</script>
<style scoped>
#logo {

  margin-bottom: 1px;
  float: right;
}

#logo img {
  width: 10px;
}

.textlabel {
  text-align: left;
}
.textlabel2 {
  text-align: right;
}
* {
  margin: 0;
  padding: 0;
}
body {
  font: 12px/1.8 "Poppins";
}
#page-wrap {
  width: 900px;
  margin: 0 auto;
}
textarea {
  border: 0;
  font: 14px Georgia, Serif;
  overflow: hidden;
  resize: none;
}
table {
  border-collapse: collapse;
}
table td,
table th {
  border: 1px solid black;
  padding: 5px;
}
#header {
  height: 35px;
  width: 100%;
  margin: 20px 0;
  background: #222;
  text-align: center;
  color: white !important;
  font: bold 18px Helvetica, Sans-Serif;
  text-decoration: uppercase;
  letter-spacing: 20px;
  padding: 8px 0px;
}
#address {
  width: 250px;
  height: 150px;
  float: left;
}
#customer {
  overflow: hidden;
}
#customer-title {
  font-size: 20px;
  font-weight: bold;
  float: left;
}
#meta {
  margin-top: 1px;
  width: 300px;
  float: right;
}
#meta td {
  text-align: right;
}
#meta td.meta-head {
  text-align: left;
  background: #eee;
}
#meta td textarea {
  width: 100%;
  height: 20px;
  text-align: right;
}
#items {
  clear: both;
  width: 100%;
  margin: 30px 0 0 0;
  border: 0px solid black;
}
#items th {
  background: #eee;
}
#items textarea {
  width: 80px;
  height: 50px;
}
#items tr.item-row td {
  border: 0;
  vertical-align: top;
}
#items td.description {
  width: 300px;
}
#items td.item-name {
  width: 175px;
}
#items td.description textarea,
#items td.item-name textarea {
  width: 100%;
}
#items td.total-line {
  border-right: 0;
  text-align: left;
}
#items td.total-value {
  border-left: 0;
  padding: 10px;
}
#items td.total-value textarea {
  height: 20px;
  background: none;
}
#items td.balance {
  background: #eee;
}
#items td.blank {
  border: 0;
}
#terms {
  text-align: center;
  margin: 20px 0 0 0;
}
#terms h5 {
  text-transform: uppercase;
  font: 13px Helvetica, Sans-Serif;
  letter-spacing: 10px;
  border-bottom: 1px solid black;
  padding: 0 0 8px 0;
  margin: 0 0 8px 0;
}
#terms textarea {
  width: 100%;
  text-align: center;
}
#receipt {
  width: 100%;
  background: white;
}
</style>